import React from 'react';

import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import Divider from '@mui/material/Divider';

import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import AddIcon from '@mui/icons-material/Add';
import SaveIcon from '@mui/icons-material/Save';
import EditIcon from '@mui/icons-material/Edit';
import SettingsIcon from '@mui/icons-material/Settings';
import PublishIcon from '@mui/icons-material/Publish';
import PreviewIcon from '@mui/icons-material/Preview';
import ClearIcon from '@mui/icons-material/Clear';
import {styled } from '@mui/material/styles';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';

import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import FormLabel from '@mui/material/FormLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import Accordion from '@mui/material/Accordion';
import AccordionActions from '@mui/material/AccordionActions';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

//import Alert from '@mui/material/Alert';
import CheckIcon from '@mui/icons-material/Check';

import CloseIcon from '@mui/icons-material/Close';

import Switch from '@mui/material/Switch';

import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';

//import { styled } from '@mui/material/styles';
//import { Box } from "@material-ui/core";

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';

const formatJson=function(s){
	return JSON.stringify(s)
}

const numberToLetter=function(i){
	return ((i+1) + 9).toString(36);
}

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'left',
  color: theme.palette.text.secondary,
  ...theme.applyStyles('dark', {
    backgroundColor: '#1A2027',
  }),
}));


function Questionnaire ({tempQuestionnaireData,tempQuestionnaireQuestionsAndSections,tempQuestionnaireSectionsQuestions,setTempResponses,tempResponses}) {

const handleOnChangeQuestionResponseValue = (e,question,key,index) => {
			//console.log('e',e);
			//console.log('question',question);
			//console.log('key',key);
			//console.log('index',index);
			let question_id=question.id;
			let type=question.type;
			//console.log('Type:',type);
			
			if(type=='text'){
				let value= e.target.value;
				setTempResponses({...tempResponses,
					[question_id]: [value],
				})
			}
			else if(type=='number'){
				let value= e.target.value;
				setTempResponses({...tempResponses,
					[question_id]: [value],
				})
			}
			else if(type=='date'){
				let value= e.$d;
				setTempResponses({...tempResponses,
					[question_id]: [value],
				})
			}
			else if(type=='time'){
				let value= e.$d;
				setTempResponses({...tempResponses,
					[question_id]: [value],
				})
			}
			else if(type=='multi_choice'){
				let value= e.target.value;
				var _temp =tempResponses[question_id];
				if(e.target.checked){//add
					_temp.push(value);
				}else{//remove
					var _index = _temp.indexOf(value);
					if (_index !== -1) {
					  _temp.splice(_index, 1);
					}
				}
				setTempResponses({...tempResponses,
					[question_id]: _temp,
				})
			}
			else if(type=='single_choice'){
					let value= e.target.value;
				setTempResponses({...tempResponses,
					[question_id]: [value],
				})
				//console.log('single choice value',value);
			}
			else if(type=='comment'){
					let value= e.target.value;
					setTempResponses({...tempResponses,
						[question_id]: [value],
					})
			}else if(type=='list'){
					let value= e.target.value;
					var _temp =tempResponses[question_id];
					_temp[index][key]=value;
					setTempResponses({...tempResponses,
						[question_id]: _temp,
					})
			}else{
				let value= e.target.value;
				setTempResponses({...tempResponses,
					[question_id]: [value],
				})
				
			}
			console.log(tempResponses[question_id]);
				
	}
	
	//handleAddListResponse
	const handleAddListResponse = (e,question) => {
		addBlankListItemToQuestion(question);
	};
	
	
	function addBlankListItemToQuestion(question){
		console.log('question',question);
		const newReponses = {...tempResponses};
		let _fields ={};
		for(let f=0;f<question.field_list.length;f++){
			_fields[question.field_list[f].field]=''
		}
		newReponses[question.id].push(_fields);
		setTempResponses(newReponses);
	}
	
	const handleRemoveListResponse = (e,question,index) => {
		removeBlankListItemToQuestion(question,index);
	};
	
	function removeBlankListItemToQuestion(question,index){
		console.log('question',question);
		const newReponses = {...tempResponses};
		newReponses[question.id].splice(index,1);
		setTempResponses(newReponses);
	}
	
			//question section
		const handleOnChangeQuestionSectionResponseValue = (e,question_section,question,key,index) => {
			console.log('e',e);
			console.log('question_section',question_section);
			console.log('question',question);
			let question_section_id=question_section.id;
			let question_id=question.id;
			let display_type=question_section.display_type;
			if(display_type=='table'){
				let question_type=question_section.question_type;
				console.log('question_type',question_type)
				if(question_type=='single_choice'){
						let value= e.target.value;
					setTempResponses({...tempResponses,
						[question_id]: [value],
					})
				}
				if(question_type=='single_choice_text'){
						let value= e.target.value;
						var _temp =tempResponses[question_id];
						console.log('_temp',_temp);
						console.log('key',key);
						let t={};
						for(let _k in _temp){
							t[_k]='';
						}//test
						//if(typeof _temp =="undefined"){
						//	_temp=[{}];
						//}
						//clear all other values
						t[key]=value;
						//_temp[0][key]=value;
					setTempResponses({...tempResponses,
						[question_id]: t,
					})
				}
				
			}else{//mixed 
				if(type=='text'){
					let value= e.target.value;
					setTempResponses({...tempResponses,
						[question_id]: [value],
					})
				}
				else if(type=='number'){
					let value= e.target.value;
					setTempResponses({...tempResponses,
						[question_id]: [value],
					})
				}
				else if(type=='date'){
					let value= e.target.value;
					setTempResponses({...tempResponses,
						[question_id]: [value],
					})
				}
				else if(type=='time'){
					let value= e.target.value;
					setTempResponses({...tempResponses,
						[question_id]: [value],
					})
				}
				else if(type=='multi_choice'){
					let value= e.target.value;
					var _temp =tempResponses[question_id];
					if(e.target.checked){//add
						_temp.push(value);
					}else{//remove
						var _index = _temp.indexOf(value);
						if (_index !== -1) {
						  _temp.splice(_index, 1);
						}
					}
					setTempResponses({...tempResponses,
						[question_id]: _temp,
					})
				}
				else if(type=='single_choice'){
						let value= e.target.value;
					setTempResponses({...tempResponses,
						[question_id]: [value],
					})
				}
				else if(type=='comment'){
						let value= e.target.value;
						setTempResponses({...tempResponses,
							[question_id]: [value],
						})
				}else{
					let value= e.target.value;
					setTempResponses({...tempResponses,
						[question_id]: [value],
					})
				}
			}
		}
	return (
		<div>
		<h3>{tempQuestionnaireData.title}</h3>
		
		<Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }}>
				{tempQuestionnaireQuestionsAndSections.map((q,index) => (
				  <Grid   item xs={12} sm={12} md={12} key={index}>
					
					{/*QUESTION*/}
					{q._type=='Question' &&
					<>
					<Item sx={{ padding: '25px' }}   >
					<h3><b>{q.heading}</b></h3>
					<Box sx={{ color: 'text.primary' }}>{index+1}) {q.question}</Box>
					<Box sx={{ color: 'text.secondary' }}>&nbsp;&nbsp;&nbsp;&nbsp;{q.help_text}</Box>
						{/*text*/}
						{q.type=='text' &&
						<>
							<TextField  margin="normal" required fullWidth id="" label="" name=""
								value={tempResponses[q.id]}
								onChange={(e) => {handleOnChangeQuestionResponseValue(e,q)}}
							/>
						</>}
						{/*number*/}
						{q.type=='number' &&
						<>
							<TextField inputProps={{ type: 'number'}}  margin="normal" required fullWidth id="" label="" name=""
								value={tempResponses[q.id]}
								onChange={(e) => {handleOnChangeQuestionResponseValue(e,q)}}
							/>			
						</>}
						{/*time*/}
						{q.type=='time' &&
						<>
							<LocalizationProvider  dateAdapter={AdapterDayjs}>
							<DemoContainer sx={{ m: 1, width: '500px'}} components={['TimePicker']}>
								<TimePicker
								  name=""
								  label=""
								 // value={timeNow}
								  ampm={false}
								  onChange={(e) => {handleOnChangeQuestionResponseValue(e,q)}}
								/>
							  </DemoContainer>
							</LocalizationProvider>
						</>}
						{/*date*/}
						{q.type=='date' &&
						<>
							<LocalizationProvider  dateAdapter={AdapterDayjs}>
							<DemoContainer sx={{ m: 1, width: '500px'}} components={['DatePicker']}>
								<DatePicker 
								  name=""
								  label=""
								  format="DD/MM/YYYY"
								 // value={dateNow}
								 // ampm={false}
								  onChange={(e) => {handleOnChangeQuestionResponseValue(e,q)}}
								/>
							</DemoContainer>
							</LocalizationProvider>
						</>}
						{/*comment*/}
						{q.type=='comment' &&
							 <>			
							<TextField  id=""  label="" name=""  multiline rows={4}  sx={{ width: '100%' }}
								value={tempResponses[q.id]}
								onChange={(e) => {handleOnChangeQuestionResponseValue(e,q)}}
								inputProps={{ maxLength: q.settings.max_length }}
							/>
							{tempResponses[q.id][0] && <>
								{tempResponses[q.id][0].length}/{q.settings.max_length } Max char
							</>}
							{!tempResponses[q.id][0] && <>
								0/{q.settings.max_length } Max char
							</>} 						  
										
						</>}
						{/*single choice*/}						
						{q.type=='single_choice' &&
						<>
							<FormControl>
								<FormLabel id="demo-radio-buttons-group-label"></FormLabel>
								<RadioGroup
									aria-labelledby="demo-radio-buttons-group-label"
									//defaultValue="unknown"
									name="radio-buttons-group"
									onChange={(e) => {handleOnChangeQuestionResponseValue(e,q)}}
								>
								{q.choices.map((opt,index) => (
									<FormControlLabel key={index} value={opt} control={<Radio />} label={opt} />
								))}
								{q.other_choice_added &&
									<FormControlLabel value={q.other_choice_text} control={<Radio />} label={q.other_choice_text} />
								}
								</RadioGroup>
							</FormControl>
							<br/>
							{q.other_choice_added &&
								<TextField  inputProps={{ type: 'text'}} size="small"  margin="dense" id="" label="" name=""
									value={tempResponses[q.id]}
									onChange={(e) => {handleOnChangeQuestionResponseValue(e,q)}}
								/>
							}
						</>}
						{/*multi choice*/}
						{q.type=='multi_choice' &&
						<>
							<FormGroup
								onChange={(e) => {handleOnChangeQuestionResponseValue(e,q)}}
							>
								{q.choices.map((opt,index) => (
									<FormControlLabel key={index} value={opt} control={<Checkbox />} label={opt} />
								))}
							</FormGroup>
						</>}
						{/*list*/}
						{q.type=='list' &&
						<>
							<br/>
							{tempResponses[q.id].map((field_list,i) => (
							<>
									<TableContainer key={i} component={Paper}>
									  <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
										<TableHead>
										  <TableRow>
											<TableCell align="left">{q.list_name} {i+1}</TableCell>
											<TableCell align="right">
												 <Button variant="contained" onClick={(e) => handleRemoveListResponse(e,q,i)}  >
													Remove
												  </Button>
											</TableCell>
										
									
										  </TableRow>
										</TableHead>
										<TableBody>
									
										  {q.field_list.map((field_list,index) => (
											<TableRow
											  key={index}
											  sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
											>
											  <TableCell align="left">
												<Box sx={{ color: 'text.primary' }}>{field_list.field}</Box>
												<Box sx={{ color: 'text.secondary' }}>{field_list.help_text}</Box>
											  </TableCell>
											  <TableCell align="left">
													<TextField  inputProps={{ type: 'text'}} size="small"  margin="dense" id="" label="" name=""
														value={tempResponses[q.id][i][field_list.field]}
														onChange={(e) => {handleOnChangeQuestionResponseValue(e,q,field_list.field,i)}}
													/>
											  </TableCell>
									
											</TableRow>
										  ))}
										</TableBody>
									  </Table>
									</TableContainer>
									<br/>
									</>
							))}
							<br/>
							<Button variant="contained" onClick={(e) => handleAddListResponse(e,q)}  >
								Add {q.list_name}
							</Button>
							  
						</>}
							
						</Item>
					</>}
					
					{/* Section */}
					{q._type=='Section' &&
					<>
						<Item sx={{ padding: '25px' }} >
						<Box sx={{ color: 'text.primary' }}>{index+1}) {q.title}</Box>
						<Box sx={{ color: 'text.secondary' }}>&nbsp;&nbsp;&nbsp;&nbsp;{q.help_text}</Box>
						
						{tempQuestionnaireSectionsQuestions[q.id].length==0 &&
						<>
							No questions
						</>}
						
						{tempQuestionnaireSectionsQuestions[q.id].length>0 &&
						<>
						{q.display_type=='table' &&
							<>
							<br/>
							{q.question_type=='single_choice_text' &&
								<TableContainer  component={Paper}>
								  <Table  sx={{ border: 1 }} size="small" aria-label="a dense table">
									<TableHead>
									  <TableRow  sx={{ border: 1 }}>
										<TableCell  sx={{ border: 1 }} align="center">{q.sub_title}</TableCell>
											{q.choices.map((opt,i) => (
												<TableCell key={i}  sx={{ border: 1 }} align="center">{opt}</TableCell>
											))}
							
									  </TableRow>
									</TableHead>
									<TableBody>
									  {tempQuestionnaireSectionsQuestions[q.id].map((sub_question,s) => (
										<TableRow  sx={{ border: 1 }} key={s}  >
										
										  <TableCell sx={{ border: 1 }} align="left">
											<Box sx={{ color: 'text.primary' }}>{sub_question.question}</Box>
												<Box sx={{ color: 'text.secondary' }}>{sub_question.help_text}</Box>
										  </TableCell>
										 
										{q.choices.map((opt,i) => (
													<TableCell  sx={{ border: 1 }} key={i}  align="center">
													  <TextField  margin="normal" required fullWidth id="" label="" name=""
													  value={tempResponses[sub_question.id][[opt]]}
															onChange={(e) => {handleOnChangeQuestionSectionResponseValue(e,q,sub_question,opt)}}
														/>
													</TableCell>
											  
											 ))}
										</TableRow>
										
										))}{/*end  sub questions */} 
											  
										
									</TableBody>
								  </Table>
								</TableContainer>
								
							}{/*text table */}
							
							{q.question_type=='single_choice' &&
							<>
								<TableContainer  component={Paper}>
								  <Table  sx={{ border: 1 }} size="small" aria-label="a dense table">
									<TableHead>
									  <TableRow  sx={{ border: 1 }}>
										<TableCell  sx={{ border: 1 }} align="center">{q.sub_title}</TableCell>
											{q.choices.map((opt,i) => (
											<TableCell key={i}  sx={{ border: 1 }} align="center">{opt}</TableCell>
										))}
							
									  </TableRow>
									</TableHead>
									<TableBody>
											  
									  {tempQuestionnaireSectionsQuestions[q.id].map((sub_question,s) => (
										<TableRow  sx={{ border: 1 }} key={s}  >
										
										  <TableCell sx={{ border: 1 }} align="left">
											<Box sx={{ color: 'text.primary' }}>{sub_question.question}</Box>
											<Box sx={{ color: 'text.secondary' }}>{sub_question.help_text}</Box>
										  </TableCell>
											  {q.choices.map((opt,i) => (
												  <TableCell  sx={{ border: 1 }} key={i}  align="center">
												  <input type="radio" value={opt} checked={tempResponses[sub_question.id]==opt} onChange={(e) => {handleOnChangeQuestionSectionResponseValue(e,q,sub_question)}} />
													  {/*	<FormControlLabel value={opt} control={<Radio />}    labelPlacement="bottom"  />
											  */} </TableCell>
											  
											 ))}
											 {/*  </RadioGroup>
									  </FormControl>*/}
										
										</TableRow>
										
										))}{/*end  sub questions */} 
											  
											
									  
									</TableBody>
								  </Table>
								</TableContainer>
								{tempQuestionnaireSectionsQuestions[q.id].map((sub_question,s) => (
								<>{sub_question.footnote}</>
								))}{/*end  sub questions */} 
								</>
							}{/*single choice table */}
						
						</>
						}
						
						{q.display_type=='list' &&
						<>
						{tempQuestionnaireSectionsQuestions[q.id].map((sub_question,s) => (
						<>
						<h4>{sub_question.heading}</h4>
						<Box sx={{ marginLeft:'25px' }} >{numberToLetter(s)}. {sub_question.question}
							<br/>
							{/*text*/}
							{sub_question.type=='text' &&
							<>
								<TextField  margin="normal" required fullWidth id="" label="" name=""
									value={tempResponses[sub_question.id]}
									onChange={(e) => {handleOnChangeQuestionResponseValue(e,sub_question)}}
								/>
							</>}
							{/*number*/}
							{sub_question.type=='number' &&
							<>
								<TextField inputProps={{ type: 'number'}}  margin="normal" required fullWidth id="" label="" name=""
									value={tempResponses[sub_question.id]}
									onChange={(e) => {handleOnChangeQuestionResponseValue(e,sub_question)}}
								/>			
							</>}
							{/*time*/}
							{sub_question.type=='time' &&
							<>
								<LocalizationProvider  dateAdapter={AdapterDayjs}>
								<DemoContainer sx={{ m: 1, width: '500px'}} components={['TimePicker']}>
									<TimePicker
									  name=""
									  label=""
									 // value={timeNow}
									  ampm={false}
									  onChange={(e) => {handleOnChangeQuestionResponseValue(e,sub_question)}}
									/>
								  </DemoContainer>
								</LocalizationProvider>
							</>}
							{/*date*/}
							{sub_question.type=='date' &&
							<>
								<LocalizationProvider  dateAdapter={AdapterDayjs}>
								<DemoContainer sx={{ m: 1, width: '500px'}} components={['DatePicker']}>
									<DatePicker 
									  name=""
									  label=""
									  format="DD/MM/YYYY"
									 // value={dateNow}
									 // ampm={false}
									  onChange={(e) => {handleOnChangeQuestionResponseValue(e,sub_question)}}
									/>
								</DemoContainer>
								</LocalizationProvider>
							</>}
							{/*comment*/}
							{sub_question.type=='comment' &&
								 <>			
								<TextField  id=""  label="" name=""  multiline rows={4}  sx={{ width: '100%' }}
									value={tempResponses[sub_question.id]}
									onChange={(e) => {handleOnChangeQuestionResponseValue(e,sub_question)}}
									inputProps={{ maxLength: sub_question.settings.max_length }}
								/>
								{tempResponses[sub_question.id][0] && <>
									{tempResponses[sub_question.id][0].length}/{sub_question.settings.max_length } Max char
								</>}
								{!tempResponses[sub_question.id][0] && <>
									0/{sub_question.settings.max_length } Max char
								</>} 						  
											
							</>}
							{/*single choice*/}						
							{sub_question.type=='single_choice' &&
							<>
								<FormControl>
									<FormLabel id="demo-radio-buttons-group-label"></FormLabel>
									<RadioGroup
										aria-labelledby="demo-radio-buttons-group-label"
										//defaultValue="unknown"
										name="radio-buttons-group"
										onChange={(e) => {handleOnChangeQuestionResponseValue(e,sub_question)}}
									>
									{sub_question.choices.map((opt,index) => (
										<FormControlLabel key={index} value={opt} control={<Radio />} label={opt} />
									))}
									{sub_question.other_choice_added &&
										<FormControlLabel value={sub_question.other_choice_text} control={<Radio />} label={sub_question.other_choice_text} />
									}
									</RadioGroup>
								</FormControl>
								<br/>
								{sub_question.other_choice_added &&
									<TextField  inputProps={{ type: 'text'}} size="small"  margin="dense" id="" label="" name=""
										value={tempResponses[sub_question.id]}
										onChange={(e) => {handleOnChangeQuestionResponseValue(e,sub_question)}}
									/>
								}
							</>}
							{/*multi choice*/}
							{sub_question.type=='multi_choice' &&
							<>
								<FormGroup
									onChange={(e) => {handleOnChangeQuestionResponseValue(e,sub_question)}}
								>
									{sub_question.choices.map((opt,index) => (
										<FormControlLabel key={index} value={opt} control={<Checkbox />} label={opt} />
									))}
								</FormGroup>
							</>}
						</Box>
						</>
						))}
						</>
						}
						
						</>}
					
						<br/>
						
						</Item>
					</>}
					
				  </Grid>
				))}
			  </Grid>
		{/*<TextField  margin="normal" required fullWidth id="" label="" name=""
								value={tempResponses['test']}
								onChange={(e) => {handleOnChangeQuestionResponseValue(e,'test')}}
/>*/}
		
		
		</div>
	)

}
export default Questionnaire;	
	
{/*
function Questionnaire ({mode,questionnaire,responses}) {

        return (
            <div>
				{mode.clientQuestionnaireModalMode=='take' ? <>
				Take Questionnaire
				{formatJson(responses)}
				
				</>:<></>}
				{mode.clientQuestionnaireModalMode=='view' ? <>//view responses
					View Questionnaire
				
					{responses.tempQuestionsAndResponses.map((q,index) => (
					<> 
						<br/>{index+1}<br/>
						<br/>{q.title}<br/>
						{q.question._type=='Question' &&
						<>
							question
						  
						</>}
						  
						{q.question._type=='Section' &&
						<>
							section
						  
						</>}
						   <br/><br/>
						   	==========================================={formatJson(q)} ===========================================<br/>
						  </>
					))}
					</>:<></>}
				
				{mode.clientQuestionnaireModalMode=='edit' ? 
				<>
				Edit Questionnaire
				</>:<></>}
	  
            </div>
        )
}

export default Questionnaire;

*/}